import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// User
const UserLogin = () => import('@/views/users/UserLogin')

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')


// Audio Station: Quản lý nhóm truyền thanh
const AudioStationList = () => import('@/views/station/audio/AudioStationList')
const AudioStationAdd = () => import('@/views/station/audio/AudioStationAdd')
const AudioStationUpdate = () => import('@/views/station/audio/AudioStationUpdate')

// Screen Station: Quản lý nhóm bảng điện tử
const ScreenStationList = () => import('@/views/station/screen/ScreenStationList')
const ScreenStationAdd = () => import('@/views/station/screen/ScreenStationAdd')
const ScreenStationUpdate = () => import('@/views/station/screen/ScreenStationUpdate')

// Audio Editor : Biên tập phát thanh + Biên tập bảng tin
/*----- Biên tập phát thanh ----- */
const AudioFileAdd = () => import('@/views/editor/audio/FileAdd')                 /* Biên tập file phát thanh */
const TextToSpeech = () => import('@/views/editor/audio/TextToSpeech')            /* Chuyển văn bản sang giọng nói phát thanh */
const MergeFile = () => import('@/views/editor/audio/MergeFile')                  /* Ghép file phát thanh */
const RecordFile = () => import('@/views/editor/audio/Record')                  /* Ghép file phát thanh */
const SendFileToStation = () => import('@/views/editor/audio/SendFileToStation')  /* Gửi bản tin tới nhóm truyền thanh */

/* ----- Biên tập bảng tin ----- */
const ScreenFileAdd = () => import('@/views/editor/screen/FileAdd')                 /* Biên tập bảng tin */
const ScreenSendFileToStation = () => import('@/views/editor/screen/SendFileToStation')  /* Gửi bản tin bảng tin điện tử */
const PlayList = () => import('@/views/editor/screen/PlayList')  /* Danh sách phát */
const PlayListAdd = () => import('@/views/editor/screen/PlayListAdd')  /* Thêm mới danh sách phát */
const PlayListUpdate = () => import('@/views/editor/screen/PlayListUpdate')  /* Cập nhật danh sách phát */

// File : Quản lý file phát thanh + Quản lý file bảng tin
/* ----- File phát thanh -----*/
const AudioFileList = () => import('@/views/files/audio/FileList')                /* Danh sách bản tin phát thanh */
const AudioFilePlaying = () => import('@/views/files/audio/FilePlaying')          /* Bản tin phát thanh đang phát */
const AudioFileBroadcast = () => import('@/views/files/audio/FileBroadcast')      /* Bản tin phát thanh đã phát */
const AudioFileHistory = () => import('@/views/files/audio/FileHistory')          /* Nhật ký phát thanh */
/* ----- File bảng tin ----- */
const ScreenFileList = () => import('@/views/files/screen/FileList')              /* Danh sách bản tin bảng tin */
const ScreenFilePlaying = () => import('@/views/files/screen/FilePlaying')        /* Bản tin bảng tin đang phát */
const ScreenFileBroadcast = () => import('@/views/files/screen/FileBroadcast')    /* Bản tin bảng tin đã phát */
const ScreenFileHistory = () => import('@/views/files/screen/FileHistory')        /* Nhật ký phát thanh */

// Devices : Quản lý thiết bị phát thanh + bảng tin
/* ----- Thiết bị phát thanh ----- */
const AudioDevicesList = () => import('@/views/devices/audio/AudioList')          /* Thiết bị phát thanh */
/* ----- Thiết bị bảng tin ----- */
const ScreenDevicesList = () => import('@/views/devices/screen/ScreenList')       /* Thiết bị bảng tin */

// Report : Báo cáo thống kê
const ReportAudioDevicesList = () => import('@/views/reports/AudioDeviceList')     /* Số lượng thiết bị phát thanh */
const ReportScreenDevicesList = () => import('@/views/reports/ScreenDeviceList')   /* Số lượng thiết bị bảng tin điện tử */
const UserPage = () => import('@/views/reports/UsersPage')                         /* Tài khoản */
const ReportAudioFileBroadcast = () => import('@/views/reports/ReportAudioFileBroadcast')
const ReportScreenFileBroadcast = () => import('@/views/reports/ReportScreenFileBroadcast')
const ReportAudioStation = () => import('@/views/reports/AudioStationList')

//Administrator
const UserActionLogList = () => import('@/views/administration/UserActionLogList') /* Nhật ký hành động */
const FileTypeList = () => import('@/views/administration/FileTypeList')     /* Nhật ký hành động */
const ContractorInformationList = () => import('@/views/administration/contractor_information/ContractorInformationList')     /* Danh sách nhà thầu */
const ContractorInformationAdd = () => import('@/views/administration/contractor_information/ContractorInformationAdd')     /* Thêm mới nhà thầu */
const ContractorInformationUpdate = () => import('@/views/administration/contractor_information/ContractorInformationUpdate')     /* Cập nhật nhà thầu */

//Document: Tài liệu
const DocumentList = () => import('@/views/document/DocumentList')
const DocumentAdd = () => import('@/views/document/DocumentAdd')

//NotificationList: Thông báo
const NotificationList = () => import('@/views/notification/NotificationList')

Vue.use(Router)
let router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  base: process.env.NODE_ENV === 'development' ? '/' : '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'Trang chủ',
      component: TheContainer,
      children: [
        {
          path: '/dashboard.html',
          name: 'Trang chủ',
          component: Dashboard,
          meta: {
            requiresAuth: true,
          }
        },
        {

          path: '/audio-station-management',
          redirect: '/audio-station-management/managed-audio-station.html',
          name: 'Quản lý nhóm truyền thanh',
          meta: {
            requiresAuth: true,
          }
          ,
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-audio-station.html',
              name: 'Danh sách nhóm truyền thanh',
              component: AudioStationList
            },
            {
              path: 'audio-station-new.html',
              name: 'Thêm mới nhóm truyền thanh',
              component: AudioStationAdd
            },
            {
              path: ':id/audio-station-update.html',
              name: 'Cập nhật nhóm truyền thanh',
              component: AudioStationUpdate
            }
          ]
        },
        {
          path: '/screen-station-management',
          redirect: '/screen-station-management/managed-screen-station.html',
          name: 'Quản lý nhóm bảng điện tử',
          meta: {
            requiresAuth: true,
          }
          ,
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-screen-station.html',
              name: 'Danh sách nhóm bảng điện tử',
              component: ScreenStationList
            },
            {
              path: 'screen-station-new.html',
              name: 'Thêm mới nhóm bảng điện tử',
              component: ScreenStationAdd
            },
            {
              path: ':id/screen-station-update.html',
              name: 'Cập nhật nhóm bảng điện tử',
              component: ScreenStationUpdate
            }
          ]
        },
        {
          path: '/audio-editor',
          redirect: '/audio-editor/upload-audio.html',
          name: 'Biên tập bản tin phát thanh',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'upload-audio.html',
              name: 'Biên tập bản tin',
              component: AudioFileAdd,
            },
            {
              path: 'text-to-speech.html',
              name: 'Chuyển đổi văn bản sang giọng đọc',
              component: TextToSpeech,
            },
            {
              path: 'merge-file.html',
              name: 'Ghép tệp âm thanh',
              component: MergeFile,
            },
            {
              path: 'record-file.html',
              name: 'Ghi âm tệp âm thanh',
              component: RecordFile,
            },
            // {
            //   path: 'cut-file.html',
            //   name: 'Cắt file âm thanh',
            //   component: CutFile,
            // },
            {
              path: 'send-to-station.html',
              name: 'Gửi bản tin tới nhóm truyền thanh',
              component: SendFileToStation
            }
          ]
        },
        {
          path: '/screen-editor',
          redirect: '/screen-editor/upload-screen.html',
          name: 'Biên tập bảng điện tử',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'upload-screen.html',
              name: 'Biên tập nội dung bảng điện tử',
              component: ScreenFileAdd,
            },
            {
              path: 'play-list.html',
              name: 'Biên tập danh sách phát',
              component: PlayList,
            },
            {
              path: 'play-list-add.html',
              name: 'Thêm mới danh sách phát',
              component: PlayListAdd,
            },
            {
              path: ':id/play-list-update.html',
              name: 'Cập nhật danh sách phát',
              component: PlayListUpdate,
            },
            {
              path: 'send-to-station.html',
              name: 'Gửi nội dung phát tới nhóm bảng tin điện tử',
              component: ScreenSendFileToStation,
            },
          ]
        },
        {
          path: '/files-device-management',
          redirect: '/files-device-management/managed-files.html',
          name: 'Quản lý phát thanh',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-files.html',
              name: 'Bản tin phát thanh đã biên tập',
              component: AudioFileList
            },
            {
              path: 'add.html',
              name: 'Thêm mới bản tin phát thanh',
              component: AudioFileAdd
            },
            {
              path: 'managed-files-broadcast.html',
              name: 'Bản tin phát thanh đã phát',
              component: AudioFileBroadcast
            },
            {
              path: 'managed-files-playing.html',
              name: 'Bản tin phát thanh đang phát',
              component: AudioFilePlaying
            },
            {
              path: 'managed-files-history.html',
              name: 'Nhật ký phát thanh',
              component: AudioFileHistory
            },
          ]
        },
        {
          path: '/files-screen-management',
          redirect: '/files-screen-management/managed-files.html',
          name: 'Quản lý bảng điện tử',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-files.html',
              name: 'Nội dung bảng điện tử đã biên tập',
              component: ScreenFileList
            },
            {
              path: 'managed-files-broadcast.html',
              name: 'Nội dung bảng điện tử đã phát',
              component: ScreenFileBroadcast
            },
            {
              path: 'managed-files-playing.html',
              name: 'Nội dung bảng điện tử đang phát',
              component: ScreenFilePlaying
            },
            {
              path: 'managed-files-history.html',
              name: 'Nhật ký phát bảng điện tử',
              component: ScreenFileHistory
            },
          ]
        },
        {
          path: '/devices-management',
          redirect: '/devices-management/audio-devices.html',
          name: 'Quản lý thiết bị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'audio-devices.html',
              name: 'Thiết bị phát thanh',
              component: AudioDevicesList
            }, {
              path: 'screen-devices.html',
              name: 'Thiết bị bảng điện tử',
              component: ScreenDevicesList
            }
          ]
        },
        {
          path: '/report-management',
          redirect: '/report-management/number-devices.html',
          name: 'Báo cáo thống kê',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'audio-stations.html',
              name: 'Báo cáo nhóm truyền thanh',
              component: ReportAudioStation
            },
            {
              path: 'audio-devices.html',
              name: 'Báo cáo thiết bị phát thanh',
              component: ReportAudioDevicesList
            },
            {
              path: 'screen-devices.html',
              name: 'Báo cáo thiết bị bảng điện tử',
              component: ReportScreenDevicesList
            },
            {
              path: 'audio-file-broadcast.html',
              name: 'Báo cáo bản tin phát thanh đã phát',
              component: ReportAudioFileBroadcast
            },
            {
              path: 'screen-file-broadcast.html',
              name: 'Báo cáo nội dung bảng điện tử đã phát',
              component: ReportScreenFileBroadcast
            },
            {
              path: 'users.html',
              name: 'Báo cáo tài khoản',
              component: UserPage
            }
          ]
        },
        {
          path: '/administrator',
          redirect: '/administrator/user-activity-log.html',
          name: 'Quản trị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'user-activity-log.html',
              name: 'Nhật ký hoạt động',
              component: UserActionLogList
            },
            {
              path: 'file-type.html',
              name: 'Quản lý lĩnh vực',
              component: FileTypeList
            },
            {
              path: 'contractor-information.html',
              name: 'Danh sách cấu hình API',
              component: ContractorInformationList
            },
            {
              path: 'contractor-information/add.html',
              name: 'Thêm mới cấu hình API',
              component: ContractorInformationAdd
            },
            {
              path: 'contractor-information/:id/update.html',
              name: 'Cập nhật cấu hình API',
              component: ContractorInformationUpdate
            }
          ]
        },
        {
          path: '/document-management',
          redirect: '/document-management/managed-document.html',
          name: 'Quản lý tài liệu',
          meta: {
            requiresAuth: true,
          }
          ,
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-document.html',
              name: 'Danh sách tài liệu',
              component: DocumentList
            },
            {
              path: 'add-document.html',
              name: 'Thêm tài liệu',
              component: DocumentAdd
            }
          ]
        },
        {
          path: '/notification-management',
          redirect: '/notification-management/managed-notification.html',
          name: 'Danh sách thông báo',
          meta: {
            requiresAuth: true,
          }
          ,
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-notification.html',
              name: 'Danh sách thông báo',
              component: NotificationList
            }
          ]
        }
      ]
    },
    {
      path: '/authorize',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/errors',
      redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true,
      }
    },

  ]
})

export default router
